export class TaxType {
  id: number = -1;
  name: string = '';
  rate: number = 0;
  createdAt: string = '';
  updatedAt: string = '';
}
